import { useState } from 'react';
import { useShopContext } from '../../context/ShopContext';
import api from '../../api/client';

export default function SettingsTab() {
  const { selectedStore, setSelectedStore } = useShopContext();
  const [storeName, setStoreName] = useState(selectedStore?.name || 'MultiStore');
  const [primaryColor, setPrimaryColor] = useState(selectedStore?.theme?.primary_color || '#4F46E5');

  const handleSave = async () => {
    if (!selectedStore) {
      alert('No store selected');
      return;
    }

    try {
      // Ensure theme object includes required id
      const updatedTheme = {
        id: selectedStore.theme?.id ?? 0, // Fallback to 0 if id is undefined
        primary_color: primaryColor,
        secondary_color: selectedStore.theme?.secondary_color,
        logo: selectedStore.theme?.logo,
      };

      await api.patch(`/stores/${selectedStore.id}/`, {
        name: storeName,
        theme: updatedTheme,
      });

      setSelectedStore({
        ...selectedStore,
        name: storeName,
      });
      alert('Settings updated successfully');
    } catch (err) {
      alert('Failed to update settings');
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <h2 className="text-xl font-bold mb-6">Store Settings</h2>
      <form className="space-y-4 max-w-lg">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Store Name</label>
          <input
            type="text"
            className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-primary focus:border-primary"
            value={storeName}
            onChange={(e) => setStoreName(e.target.value)}
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Primary Color</label>
          <input
            type="color"
            className="w-16 h-10"
            value={primaryColor}
            onChange={(e) => setPrimaryColor(e.target.value)}
          />
        </div>
        <button
          type="button"
          className="bg-primary text-white px-4 py-2 rounded hover:bg-primary-dark"
          onClick={handleSave}
        >
          Save Changes
        </button>
      </form>
    </div>
  );
}